import { capitalize } from './capitalize';
import { isLoggedIn } from './isLoggedIn';
import { showSnackBar } from './showSnackBar';
import { getGenerator } from './getGenerator';
import { promiseTimeout } from './promiseTimeout';
import { seriliazeParams } from './seriliazeParams';
import { useState } from 'react';
import { Grid, message } from 'antd';
import moment from "moment-timezone";


export const helpers = {
    capitalize,
    isLoggedIn,
    showSnackBar,
    getGenerator,
    promiseTimeout,
    seriliazeParams,
}


export const getRoleID = () => {
    return localStorage.getItem("role_id") || []
}

export const haveAccessByRole = (compareAgainst, type = "equals") => {

    let roles = JSON.parse(localStorage.getItem("user_profile"))?.role_id || []
    switch (type) {
        case "equals":
            return roles?.includes(compareAgainst) || false
        case "array":
            return roles?.some(x => compareAgainst?.includes(x))
        default:
            return false
    }
}

export const errorMessage = () => {
    message.destroy()
    return message.error("Access denied. Please login")
}

export const NoTokenLogout = (history) => {
    let token = localStorage.getItem("access_jwt")

    if (!token) {
        history.push('/login/140040')
        localStorage.clear()
        localStorage.setItem('user_profile', JSON.stringify({}))
        errorMessage()
    }
}

export const CreateQueryParams = (payload = {}) => {
    let str = ''
    Object.keys(payload)?.forEach((key, i) => {
        if (payload[key]) {
            if (i == 0)
                str += `?${key}=${payload[key]}`
            else
                str += `&${key}=${payload[key]}`
        }
    })
    return str
}


export function removeDuplicateObjects(arr) {
    const uniqueObjects = [];
    const seenObjects = new Set();
    for (const obj of arr) {
        const objString = JSON.stringify(obj);
        if (!seenObjects.has(objString)) {
            seenObjects.add(objString);
            uniqueObjects.push(obj);
        }
    }

    return uniqueObjects;
}
